import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Chapter } from "./Chapter";

const ease = [0.22, 1, 0.36, 1];

export const Leadership = () => {
  const { t } = useLang();
  return (
  <section id="leadership" data-testid="leadership-section" className="py-24 md:py-32 px-6 lg:px-10 max-w-7xl mx-auto">
    <Chapter number="04" overline={t.chapters.leadership.overline} title={t.chapters.leadership.title} />

    <motion.blockquote
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease }}
      data-testid="leadership-quote"
      className="border-l-2 border-volt pl-8 md:pl-12 mb-20 max-w-3xl"
    >
      <p className="font-heading font-bold text-2xl md:text-4xl tracking-tight text-paper leading-tight">
        {t.leadQuote}
      </p>
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-dim mt-6">
        {t.leadSub}
      </p>
    </motion.blockquote>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {t.skills.map((s, i) => (
        <motion.div
          key={s.name}
          data-testid={`skill-item-${i}`}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease }}
          className="border border-line -mt-px -ml-px p-8 md:p-10 group hover:bg-graphite transition-colors duration-500"
        >
          <span className="font-mono text-xs text-dim tracking-[0.25em]">0{i + 1}</span>
          <h3 className="font-heading font-bold text-lg md:text-xl tracking-tight text-paper mt-4 group-hover:text-volt transition-colors">
            {s.name}
          </h3>
          <p className="font-body text-sm text-dim mt-3 leading-relaxed">{s.detail}</p>
        </motion.div>
      ))}
    </div>
  </section>
  );
};
